import { defineStore } from 'pinia';
import { store } from '/@/store';

import {
  FormTypeEnum,
  MemberTypeEnum,
  MemberCategoryEnum,
  StatusTypeEnum,
  ValidTypeEnum,
  investorsTypeEnum,
} from '/@/enums/accountEnum';
import {
  individualInfoType,
  enterpriseInfoType,
  institutionInfoType,
  settlementBankAccountInfoType,
  documentItem,
} from '/#/obboarding';

//import { LOCALE_KEY } from '/@/enums/cacheEnum';
import { addOnboardingsApi, fetchOnboardingsApi } from '/@/api/account';
import { useMessage } from '/@/hooks/web/useMessage';
import { useI18n } from '@mcex/locale';
// import { PageEnum } from '/@/enums/pageEnum';
// import { router } from '/@/router';
interface RegisterState {
  registerType: MemberTypeEnum;
  id: Nullable<string>;
  status?: Nullable<StatusTypeEnum>;
  onboardingFinish?: boolean;
  validForms: Map<FormTypeEnum, any>;
  validResult?: Record<FormTypeEnum, ValidTypeEnum>;
  memberCategory: Nullable<MemberCategoryEnum>;
  individualInfo: Nullable<individualInfoType>;
  institutionInfo: Nullable<institutionInfoType>;
  enterpriseInfo: Nullable<enterpriseInfoType>;
  settlementBankAccountInfo: Nullable<settlementBankAccountInfoType>;
}
const initInfo = {
  individualInfo: {
    taxResidenceAddress: {},
    taxMailingAddress: {},
    taxTinItems: [
      {
        taxIdentificationNumber: '',
        taxResident: '',
        noTinReasonForTypeB: '',
      },
    ],
    memberServiceAgreementConfirmation: {},
    droInvestmentAgreementConfirmation: {},
    questions: {},
    documents: {},
  },
  enterpriseInfo: {
    memberServiceAgreementConfirmation: {},
    droInvestmentAgreementConfirmation: {},
    taxOfficeAddress: {},
    taxMailingAddress: {},
    taxControllingPeople: [
      {
        title: '',
        familyName: '',
        givenName: '',
        middleName: '',
        dob: null,
        placeOfBirth: '',
        countryOfBirth: '',
        businessAddress: {
          detail: '',
          city: '',
          province: '',
          country: '',
          zipCode: '',
        },
        mailAddress: {
          detail: '',
          city: '',
          province: '',
          country: '',
          zipCode: '',
        },
        accountHolderName: '',
        tinItems: [
          {
            taxIdentificationNumber: '',
            taxResident: '',
            noTinReasonType: undefined,
            noTinReasonForTypeB: '',
          },
        ],
        controllerPersonTypes: [
          {
            entityName: '',
          },
        ],
        printName: '',
        signatureDate: null,
        signatoryCapacity: '',
      },
    ],
    controllerPersonTypes: [
      {
        entityName: '',
      },
    ],
    taxTinItems: [
      {
        taxIdentificationNumber: '',
        taxResident: '',
        noTinReasonForTypeB: '',
      },
    ],
    questions: {},
    documents: {},
    // directDocType: DirectDocTypeEnum.RESOLUTION,
    directDocType: '',
  },
  institutionInfo: {
    memberServiceAgreementConfirmation: {},
    droInvestmentAgreementConfirmation: {},
    taxOfficeAddress: {},
    taxMailingAddress: {},
    taxControllingPeople: [
      {
        title: '',
        familyName: '',
        givenName: '',
        middleName: '',
        dob: null,
        placeOfBirth: '',
        countryOfBirth: '',
        businessAddress: {
          detail: '',
          city: '',
          province: '',
          country: '',
          zipCode: '',
        },
        mailAddress: {
          detail: '',
          city: '',
          province: '',
          country: '',
          zipCode: '',
        },
        accountHolderName: '',
        tinItems: [
          {
            taxIdentificationNumber: '',
            taxResident: '',
            noTinReasonType: undefined,
            noTinReasonForTypeB: '',
          },
        ],
        controllerPersonTypes: [
          {
            entityName: '',
          },
        ],
        printName: '',
        signatureDate: null,
        signatoryCapacity: '',
      },
    ],
    controllerPersonTypes: [
      {
        entityName: '',
      },
    ],
    taxTinItems: [
      {
        taxIdentificationNumber: '',
        taxResident: '',
        noTinReasonForTypeB: '',
      },
    ],
    documents: {},
    directDocType: '',
  },
  settlementBankAccountInfo: {},
};

function getFormKeys(type: MemberTypeEnum) {
  switch (type) {
    case MemberTypeEnum.INDIVIDUAL:
      return [FormTypeEnum.ENTITY, FormTypeEnum.TAX, FormTypeEnum.QUESTION, FormTypeEnum.ARCHIVE];
    case MemberTypeEnum.COMPANY:
      return [
        FormTypeEnum.ENTITY,
        FormTypeEnum.TAX,
        FormTypeEnum.QUESTION,
        FormTypeEnum.RESOLUTION,
        FormTypeEnum.ARCHIVE,
      ];
    case MemberTypeEnum.INSTITUTION:
      return [FormTypeEnum.ENTITY, FormTypeEnum.TAX, FormTypeEnum.RESOLUTION, FormTypeEnum.ARCHIVE];
  }
}
export const useRegisterFormStore = defineStore({
  id: 'register-form',
  state: (): RegisterState => ({
    id: null,
    registerType: MemberTypeEnum.INSTITUTION,
    status: null,
    validForms: new Map(),
    validResult: undefined,
    memberCategory: null,
    individualInfo: null,
    enterpriseInfo: null,
    institutionInfo: null,
    settlementBankAccountInfo: null,
  }),
  getters: {
    getStatus(): StatusTypeEnum {
      return this.status || StatusTypeEnum.DRAFT;
    },
    /** 获取数据用于表单提交 */
    getInfo(): any {
      const res = this[`${this.registerType}Info`];
      if (res) {
        // 如果已阅读协议则初始化memberAgree为true
        if (res.memberServiceAgreementConfirmation.onBehalfOfExchangeMember) {
          res.memberAgree = true;
        }
        // 如果已阅读协议则初始化memberAgree为true
        if (res.droInvestmentAgreementConfirmation.onBehalfOfExchangeMember) {
          res.droAgree = true;
        }
        return res;
      }
      this[`${this.registerType}Info`] = JSON.parse(
        JSON.stringify(initInfo[`${this.registerType}Info`]),
      );

      return this[`${this.registerType}Info`];
    },
    getSettlementBankInfo(): any {
      if (this.settlementBankAccountInfo) {
        return this.settlementBankAccountInfo;
      }
      this.settlementBankAccountInfo = JSON.parse(
        JSON.stringify(initInfo.settlementBankAccountInfo),
      );
      return this.settlementBankAccountInfo;
    },
    getInvestorsTypeEnum(): investorsTypeEnum {
      return investorsTypeEnum[this.registerType];
    },
    getQuestionsForm(): any {
      if (!this.getInfo.questions) {
        this.getInfo.questions = {};
        return this.getInfo.questions;
      }
      if (Array.isArray(this.getInfo.questions)) {
        const questionsArr = JSON.parse(JSON.stringify(this.getInfo.questions));
        const resObj = {};
        questionsArr.forEach((item) => {
          resObj[`question${item.number}`] = item.score;
        });
        this.getInfo.questions = resObj;
        return this.getInfo.questions;
      }
      return this.getInfo.questions;
    },
    getQuestions(): any {
      const questions = this.getInfo.questions;
      const ans: { number: number; score: number }[] = [];
      Object.keys(questions).forEach((key) => {
        ans.push({
          number: Number(key.split('question')[1]),
          score: questions[key],
        });
      });
      return ans;
    },
    getQuestionsTotalScore(): number {
      const scores = Object.values(this.getQuestionsForm) as number[];
      return scores.reduce((current, sum) => sum + current, 0);
    },
    getDocumentsForm(): any {
      if (!this.getInfo.documents || Object.keys(this.getInfo.documents).length === 0) {
        this.getInfo.documents = {};
      }
      if (Array.isArray(this.getInfo.documents)) {
        // 后端记录的回显
        const originDocs = JSON.parse(JSON.stringify(this.getInfo.documents));
        const documents = {};
        originDocs.forEach((originDoc) => {
          documents[originDoc.categoryId] = originDoc.files;
        });
        this.getInfo.documents = documents;
      }
      return this.getInfo.documents;
    },
    getDocuments(): any {
      const originRecords = this.getDocumentsForm;
      const documents: documentItem[] = [];
      const { t } = useI18n();
      Object.keys(originRecords).forEach((key) => {
        documents.push({
          categoryId: Number(key),
          categoryName: t(`account.document.file${key}`),
          files: originRecords[key],
        });
      });
      return documents;
    },
  },
  actions: {
    setValidResult(validRes: Record<FormTypeEnum, ValidTypeEnum>) {
      this.validResult = validRes;
    },
    setValidForms(key: FormTypeEnum, validForm: () => Promise<any>) {
      this.validForms.set(key, validForm);
    },
    clearValidForms() {
      this.validForms.clear();
    },
    setRegisterType(type: MemberTypeEnum) {
      this.registerType = type;
    },
    setMemberCategory(category: MemberCategoryEnum) {
      this.memberCategory = category;
    },
    /** 邮寄地址复用居住地址 */
    mailCopyFromResidence() {
      this.getInfo.taxMailingAddress = JSON.parse(JSON.stringify(this.getInfo.taxResidenceAddress));
    },
    /** 邮寄地址复用居住地址 */
    mailCopyFromOffice() {
      this.getInfo.taxMailingAddress = JSON.parse(JSON.stringify(this.getInfo.taxOfficeAddress));
    },
    /** 邮寄地址复用企业地址 */
    mailCopyFromTaxControlOffice(index) {
      this.getInfo.taxControllingPeople[index].mailAddress = JSON.parse(
        JSON.stringify(this.getInfo.taxControllingPeople[index].businessAddress),
      );
    },
    /**
     * 重置数据
     */
    async resetInfo() {
      this[`${this.registerType}Info`] = null;
    },
    /**
     * Set up multilingual information and cache
     * @param info multilingual info
     */
    updateIndividualInfo(info: any) {
      this.individualInfo = { ...this.individualInfo, ...info };
    },
    /**
     *
     * @param info
     */
    updateInstitutionalInfo(info: any) {
      this.institutionInfo = { ...this.institutionInfo, ...info };
    },

    /**
     * 获取表单数据用于提交
     */
    getFormDataFromStore() {
      const info = JSON.parse(JSON.stringify(this.getInfo));
      // 需要问卷调查
      if ([MemberTypeEnum.INDIVIDUAL, MemberTypeEnum.COMPANY].includes(this.registerType)) {
        info.questions = this.getQuestions;
      } else {
        info.questions = [];
      }
      info.directDocType = Number(info.directDocType);
      info.documents = this.getDocuments;
      return {
        id: this.id,
        onboardingFinish: false,
        investorsType: this.getInvestorsTypeEnum,
        memberCategory: this.memberCategory,
        [`${this.registerType}Info`]: info,
      };
    },

    /**
     * 提交申请
     */
    async submit() {
      try {
        const curFormKeys = getFormKeys(this.registerType);
        // 遍历formRefs
        // const valids = validForms.map((valid) => valid());
        const valids = curFormKeys.map((key) =>
          this.validForms.get(key) ? this.validForms.get(key)() : Promise.reject({ key }),
        );
        const res = await Promise.allSettled(valids);
        // 遍历结果
        const results = {};
        let isOK = ValidTypeEnum.SUCCESS;
        res.forEach((item) => {
          if (item.status === 'rejected') {
            results[item.reason?.key] = ValidTypeEnum.FAIL;
            isOK = ValidTypeEnum.FAIL;
          } else {
            results[item.value?.key] = ValidTypeEnum.SUCCESS;
          }
        });
        // TODO: 由于顶部进度条点击后才会加载表单，所以在问访问表单页面时，这里无法收集到表单的校验结果，需要增加默认校验结果
        this.validResult = results as Record<FormTypeEnum, ValidTypeEnum>;

        const { createMessage } = useMessage();
        // 校验通过提交数据
        if (isOK === ValidTypeEnum.SUCCESS) {
          const params = this.getFormDataFromStore();
          params.onboardingFinish = true;
          const res = await addOnboardingsApi(params);
          const { t } = useI18n();

          this.id = res;
          // 更新状态
          this.status = StatusTypeEnum.APPLICATION_REVIEWING;
          createMessage.success(t('account.common.comfirmSuccessTip'), 1.5);
          return Promise.resolve(true);
        }
        // const { createMessage } = useMessage();
        // createMessage.warning('请检查表单是否填写正确');
        createMessage.error('请先完善信息', 1.5);
        // 校验失败
        return Promise.reject(false);
      } catch (error) {
        throw error;
      }
    },

    /**
     * 保存数据
     */
    async save() {
      try {
        const params = this.getFormDataFromStore();
        const res = await addOnboardingsApi(params);
        const { createMessage } = useMessage();
        const { t } = useI18n();

        this.id = res;
        createMessage.success(t('保存成功'));
      } catch (error) {
        throw error;
      }
    },
    async autoSave() {
      try {
        const params = this.getFormDataFromStore();
        const res = await addOnboardingsApi(params);
        this.id = res;
      } catch (error) {
        throw error;
      }
    },
    // 新增Tin
    addTin() {
      if (!Array.isArray(this.getInfo.taxTinItems)) this.getInfo.taxTinItems = [];
      this.getInfo.taxTinItems.push({
        taxIdentificationNumber: '',
        taxResident: '',
        noTinReasonForTypeB: '',
      });
    },
    // 删除Tin
    deleteTin(index: number) {
      this.getInfo.taxTinItems?.splice(index, 1);
    },
    // 获取远程会员申请数据
    async fetchOnboardings() {
      try {
        const res1 = await fetchOnboardingsApi();
        console.log('res', res1);
        if (res1 == null) {
          this.individualInfo = null;
          this.enterpriseInfo = null;
          this.institutionInfo = null;
        }
        this.id = res1?.id || null;
        this.onboardingFinish = res1?.onboardingFinish;
        this.status = res1?.status as StatusTypeEnum;
        this.memberCategory = res1.memberCategory as MemberCategoryEnum;
        this.registerType = investorsTypeEnum[res1.investorsType] as MemberTypeEnum;
        // 如果idbu存在，则重置

        this[`${this.registerType}Info`] = {
          ...JSON.parse(JSON.stringify(initInfo[`${this.registerType}Info`])),
          ...res1[`${this.registerType}Info`],
        };
      } catch (error) {
        console.log('fetchOnboardings error =>', error);
      }
    },
    // 新增taxControllingPeople
    addTaxControllingPeople() {
      if (!Array.isArray(this.getInfo.taxControllingPeople)) this.getInfo.taxControllingPeople = [];
      this.getInfo.taxControllingPeople.push({
        title: '',
        familyName: '',
        givenName: '',
        middleName: '',
        dob: null,
        placeOfBirth: '',
        countryOfBirth: '',
        businessAddress: {
          detail: '',
          city: '',
          province: '',
          country: '',
          zipCode: '',
        },
        mailAddress: {
          detail: '',
          city: '',
          province: '',
          country: '',
          zipCode: '',
        },
        accountHolderName: '',
        tinItems: [
          {
            taxIdentificationNumber: '',
            taxResident: '',
            noTinReasonType: undefined,
            noTinReasonForTypeB: '',
          },
        ],
        controllerPersonTypes: [
          {
            // 控權人類型
            entityName: '',
          },
        ],
        printName: '',
        signatureDate: null,
        signatoryCapacity: '',
      });
    },
    // 删除taxControllingPeople
    deleteTaxControllingPeople(index: number) {
      this.getInfo.taxControllingPeople?.splice(index, 1);
    },
    // taxControllingPeople新增Tin
    taxControllingPeopleAddTin(taxControllingPeopleIndex: number) {
      if (!Array.isArray(this.getInfo.taxControllingPeople)) this.getInfo.taxControllingPeople = [];
      if (this.getInfo.taxControllingPeople.length === 0) this.addTaxControllingPeople();
      this.getInfo.taxControllingPeople[taxControllingPeopleIndex].tinItems.push({
        taxIdentificationNumber: '',
        taxResident: '',
        noTinReasonType: undefined,
        noTinReasonForTypeB: '',
      });
    },
    // taxControllingPeople删除Tin
    taxControllingPeopleDeleteTin(taxControllingPeopleIndex: number, index: number) {
      this.getInfo.taxControllingPeople[taxControllingPeopleIndex]?.tinItems?.splice(index, 1);
    },
    // taxControllingPeople新增控权人类型
    taxControllingPeopleAddType(taxControllingPeopleIndex: number) {
      if (!Array.isArray(this.getInfo.taxControllingPeople)) this.getInfo.taxControllingPeople = [];
      if (this.getInfo.taxControllingPeople.length === 0) this.addTaxControllingPeople();
      this.getInfo.taxControllingPeople[taxControllingPeopleIndex].controllerPersonTypes.push({
        entityName: '',
      });
    },
    // taxControllingPeople删除控权人类型
    taxControllingPeopleDeleteType(taxControllingPeopleIndex: number, index: number) {
      this.getInfo.taxControllingPeople[taxControllingPeopleIndex]?.controllerPersonTypes?.splice(
        index,
        1,
      );
    },
  },
});

// Need to be used outside the setup
export function useRegisterFormStoreWithOut() {
  return useRegisterFormStore(store);
}
